import axios from 'axios';

export const getFormBySiteIdFromApi = siteId =>
  axios.get(`sites/${siteId}/form`)
    .then(response => response.data)
    .catch(error => error);
